<div class="cp-header" [ngClass]="{'cp-header-american-west': brand?.name === 'americanWest', 'cp-header-john-wieland': brand?.name === 'johnWieland', 'cp-header-centex': brand?.name === 'centex', 'cp-client-management-tablet': isOnClientManagementPage}">
	<!-- Menu Icon for Tablet and Mobile experiences -->
	@if (isMyAccountEnabled) {
		<div *cpIfViewSize="['tablet', 'mobile']" class="cp-menu">
			<button mat-icon-button
				class="cp-menu-icon-button"
				(click)="onHamburgerClick($event)"
				aria-label="Mobile Menu"
				data-testid="menu-icon-button"
				tabindex="0">
				<mat-icon fontSet="material-symbols-outlined" class="cp-menu-icon">menu</mat-icon>
			</button>
		</div>
	}
	<!-- Holds Brand Image and Address -->
	<div class="cp-brand">
		<!-- Brand Image -->
		<img class="cp-brand-img" [src]="logoSrc" [alt]="brand?.accessibilityTitle + ' Logo'" title="Logo"/>
	</div>

	<!-- Links for desktop experience -->
	@if (isMyAccountEnabled) {
		@let realtorInfo = realtorInfo$ | async;
		<div *cpIfViewSize="'desktop'" class="cp-menu">
			<div class="cp-header-info"
				#myAccountOrigin="cdkOverlayOrigin"
				tabindex="0"
				(click)="openOverlay()"
				(keypress)="openOverlay()"
				cdkOverlayOrigin>
				<a tabindex="0" role="button" aria-controls="cp-custom-container-aria" [attr.aria-expanded]="myAccountToggle" [attr.data-id]="'MyAccount Menu Click'">
					@if (isPreviewRealtor() && realtorInfo) {
						{{ realtorInfo?.firstName + ' ' + realtorInfo?.lastName }}
					} @else {
						@let userInfo = userInfo$ | async;
						{{ userInfo?.firstName + ' ' + userInfo?.lastName }}
					}
				</a>
				<mat-icon fontSet="material-symbols-outlined" class="cp-carrot-icon">keyboard_arrow_down</mat-icon>
			</div>

			<ng-template
				cdkConnectedOverlay
				[cdkConnectedOverlayOrigin]="myAccountOrigin"
				[cdkConnectedOverlayOpen]="myAccountToggle"
				[cdkConnectedOverlayHasBackdrop]="false"
				[cdkConnectedOverlayPositions]="myAccountOverlayPositions"
				[cdkConnectedOverlayPanelClass]="'cp-my-account-menu-overlay'"
				(overlayOutsideClick)="closeOverlay()">
				<div id="cp-custom-container-aria" class="cp-overlay-content cp-my-account-popup">
					<!-- Customer, or Preview user in customer mode -->
					@if (!isRealtor && !isPreviewRealtor()) {
						<a #myAccountMenuAction mat-button [href]="myAccountUrl" target="_blank" rel="noopener noreferrer" role="button" disableRipple [attr.data-id]="'MyAccount Link Clicked'" (click)="onMyAccountClick()">
							My Account
							<mat-icon fontSet="material-symbols-outlined" iconPositionEnd>open_in_new</mat-icon>
							<span class="cp-sr-only-aria">Sends user to My Account in a new tab</span>
						</a>
					}
					@if (isRealtorEnabled) {
						<!-- 
							Customers with realtor info can access the Realtor Access page
							Preview users without realtor mode enabled can also see the Realtor Access link if they have realtor info
							!isRealtor - It's either preview or customer
							!isPreviewRealtor() - Only show if isPreviewRealtor is false - isPreviewRealtor is always false for customers, and preview users can view it by navigating to a preview/realtor route 
						-->
						@if (!isRealtor && realtorInfo && !isPreviewRealtor() && !isThirtyOneDaysPostClose) {
							<a #myAccountMenuAction mat-button role="button" tabindex="0" disableRipple [attr.data-id]="'Realtor Access Link Clicked'" (click)="onRealtorAccessClick()" (keypress)="keyPressHandler($event, onRealtorAccessClick())">
								Realtor Access
								<span class="cp-sr-only-aria">Opens Realtor Access page</span>
							</a>
						}

					}
					<!-- 
						Realtor can perform password reset and profile management
						Preview users acessing a realtor route (isPreviewRealtor() is true) with realtor info can see password reset and profile management options (read-only/disabled)
					-->
					@if (isRealtor || (isPreview && isPreviewRealtor() && realtorInfo)) {
						<button #myAccountMenuAction mat-button
							disableRipple
							[disabled]="isPreview"
							aria-label="Password Reset"
							(click)="onResetPassword()">
							Password Reset
						</button>
						<button #myAccountMenuAction mat-button
							disableRipple
							[disabled]="isPreview"
							aria-label="Profile Management"
							(click)="onProfileManagement()">
							Profile Management
						</button>
					}
					@if (showFeedbackButton) {
						<button #myAccountMenuAction mat-button
							disableRipple
							aria-label="Give Feedback"
							data-testid="give-feedback-button"
							(click)="onGiveFeedbackClick()">
							Give Feedback
						</button>
					}
					<button #myAccountMenuAction mat-button
						disableRipple
						[disabled]="isPreview"
						aria-label="Logout"
						(click)="onLogout()"
						(keypress)="keyPressHandler($event, onLogout())">
						Logout
					</button>
				</div>
			</ng-template>
		</div>
	}
</div>